import React from "react";

const Login = () => {
  return <div>Page login</div>;
};

export default Login;
